module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card",
    class: {
      'searching': _vm.searching
    },
    attrs: {
      "id": "search"
    }
  }, [_c('div', {
    staticClass: "row ml-0 align-items-center"
  }, [_c('div', {}, [_c('i', {
    staticClass: "fa fa-search p-2 fa-lg",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.$emit('toggle')
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-10 px-0"
  }, [_c('div', {
    staticClass: "row ml-0"
  }, [_c('regular-input', {
    staticClass: "col-6 my-2",
    attrs: {
      "value": _vm.input,
      "type": "text",
      "placeholder": _vm.$t('SearchBar.search')
    },
    on: {
      "input": function($event) {
        _vm.input = $event
      }
    }
  }), _vm._v(" "), _c('regular-select', {
    staticClass: "col-6 pl-0 my-2",
    attrs: {
      "value": _vm.criteria,
      "placeholder": _vm.$t('SearchBar.criteria')
    },
    on: {
      "change": function($event) {
        _vm.criteria = $event
      }
    }
  }, _vm._l((_vm.criterias), function(criteria, key) {
    return _c('option', {
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(criteria))])
  }))], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e0bcf88","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/module/Search.vue
// module id = 834
// module chunks = 1